<template>
    <div class="certificate">
        <headers :title="$t('资质证书')" img="Branch"></headers>
        <div class="CertificateList">
            <el-row v-for="(item, index) in certificateList" :key="index" :gutter="40">
                <el-col  :xs="24" :sm="24" :md="{span:7,offset:5}" :lg="{span:7,offset:5}" :xl="{span:7,offset:5}">
                    <CertificateTemplate :img1="item[0].img1" :img2="item[0].img2" :title="item[0].title" :data="item[0].data"></CertificateTemplate>
                </el-col>
                <el-col  :xs="24" :sm="24" :md="{span:7}" :lg="{span:7}" :xl="{span:7}">
                    <CertificateTemplate :img1="item[1].img1" :img2="item[1].img2" :title="item[1].title" :data="item[1].data"></CertificateTemplate>
                </el-col>
            </el-row>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import CertificateTemplate from "@/components/CertificateTemplate.vue";

export default {
    components:{
        headers,foot,CertificateTemplate
    },
    computed:{
        certificateList(){
            let arr = [
                [{
                    img1:"1",
                    img2:"2",
                    title:this.$t('波西认证'),
                    data:[
                        {title:this.$t('《质量管理体系认证证书》')},
                        {title:this.$t('认证产品：'),text:this.$t('医用一次性非灭菌无纺布制品、一次性非灭菌无纺布口罩一次性非灭菌塑料制品')}
                    ]     
                },
                {
                    img1:"3",
                    img2:"4",
                    title:this.$t('第一类医疗器械备案'),
                    data:[
                        {title:this.$t('认证产品：'),text:this.$t('医用隔离鞋套')}
                    ]     
                }],
                [{
                    img1:"5",
                    img2:"6",
                    title:this.$t('第一类医疗器械备案'),
                    data:[
                        {title:this.$t('认证产品：'),text:this.$t('隔离衣')}
                    ]     
                },
                {
                    img1:"7",
                    img2:"8",
                    title:this.$t('第一类医疗器械备案'),
                    data:[
                        {title:this.$t('认证产品：'),text:this.$t('医用帽')}
                    ]     
                }],
                [{
                    img1:"9",
                    img2:"10",
                    title:this.$t('CE证书'),
                    data:[
                    ]     
                },
                {
                    img1:"11",
                    img2:"12",
                    title:this.$t("ISO 9001 证书"),
                    data:[
                        {title:this.$t('《质量管理体系认证证书》')},
                        {title:this.$t('认证/注册范围：'),text:this.$t('无纺布制品的生产和销售')}
                    ]     
                }]
            ]
            return arr
        }
    }
}
</script>

<style lang="less">
.certificate{
    .CertificateList{
        padding-top: 3rem;
        padding-bottom: 3rem;
        width: 100%;
    }
}
</style>

<i18n>
{
  "en": {
      "资质证书":"Certifications",
      "波西认证":"Percy certification",
      "《质量管理体系认证证书》":"《Quality Management System Certification》",
      "认证产品：":"Certified products:",
      "医用一次性非灭菌无纺布制品、一次性非灭菌无纺布口罩一次性非灭菌塑料制品":"Medical disposable non-sterile non-woven products, disposable non-sterile non-woven masks, disposable non-sterile plastic products",
      "第一类医疗器械备案":"First class medical device filing",
      "医用隔离鞋套":"Medical isolation shoe cover",
      "隔离衣":"Gown",
      "医用帽":"Medical cap",
      "CE证书":"CE certificate",
      "ISO 9001 证书":"ISO 9001 certificate",
      "认证/注册范围：":"Certification / Registration Scope:",
      "无纺布制品的生产和销售":"Production and sales of non-woven products"
  },
  "zh": {
      "资质证书":"资质证书",
      "波西认证":"波西认证",
      "《质量管理体系认证证书》":"《质量管理体系认证证书》",
      "认证产品：":"认证产品：",
      "医用一次性非灭菌无纺布制品、一次性非灭菌无纺布口罩一次性非灭菌塑料制品":"医用一次性非灭菌无纺布制品、一次性非灭菌无纺布口罩一次性非灭菌塑料制品",
      "第一类医疗器械备案":"第一类医疗器械备案",
      "医用隔离鞋套":"医用隔离鞋套",
      "隔离衣":"隔离衣",
      "医用帽":"医用帽",
      "CE证书":"CE证书",
      "ISO 9001 证书":"ISO 9001 证书",
      "认证/注册范围：":"认证/注册范围：",
      "无纺布制品的生产和销售":"无纺布制品的生产和销售"
  }
}
</i18n>

